<template>
  <div class="w3-modal" style="display: block" v-if="visivel">
    <div class="w3-modal-content w3-animate-zoom">

      <h5 class="w3-left w3-col m12 titulo">
        <span
          @click="fechar()"
          class="w3-button w3-display-topright w3-text-theme w3-large">&times;</span>

        <b class="texto-vermelho">
          <i class="fas fa-barcode"></i>
          <span>Conferir Produtos</span>
        </b>
      </h5>

      <div
        class="w3-container"
        v-show="(
          (tipoConfirmacao == 'SCB') || 
          (tipoConfirmacao == 'SMA')
        )">

        <input
          type="radio"
          id="opcaoManual"
          value="MAN"
          v-model="opcao_confirmacao">

        <label for="opcaoManual">Manual</label>

        <input
          type="radio"
          id="opcaoBarras"
          value="BAR"
          v-model="opcao_confirmacao"
          @change="clicarOpcaoCodigoBarras">

        <label for="opcaoBarras">Código de barras</label>
      </div>

      <div
        class="w3-container"
        v-if="(
          (tipoConfirmacao == 'MAN') || 
          (tipoConfirmacao == 'BAR')
        )">
        <label>Tipo de confirmação:</label>
        <strong v-if="tipoConfirmacao == 'MAN'">Manual</strong>
        <strong v-if="tipoConfirmacao == 'BAR'">Código de barras</strong>
      </div>

      <div v-show="opcao_confirmacao == 'BAR'">
        <div class="w3-col s10">
          <label for="input_codigo_barras">Código de barras</label>
          <input 
            ref="campoCodigoBarras"
            class="w3-input"
            v-on:keyup.enter="lerCodigoBarras(codigo_barras)"
            v-model="codigo_barras"
            type="number"
            id="input_codigo_barras"
            style="float:left">
        </div>

        <div class="w3-col s2">
          <button
            class="w3-button"
            style="margin: auto; margin-top: 20px; margin-left: 2px;"
            @click="mostrar_leitor_codigo_barras = true">
            <i class="fas fa-camera"></i>
          </button>
        </div>

        <div class="w3-col s3 m4" v-show="alterar_quantidade">
          <label for="input_quantidade">Quantidade</label>
          <vue-numeric
            id="input_quantidade"
            ref="campoQuantidade"
            class="w3-input w3-border"
            v-bind:precision="3"
            separator="."
            v-model="quantidade">
          </vue-numeric>
        </div>

        <div class="w3-col s6 m4" v-show="!alterar_quantidade">
          <div class="w3-col s4 m4 l4">
            <button
              v-if="!alterar_quantidade"
              class="w3-button w3-theme"
              @click="ativarEdicaoQuantidade()"
              style="margin: auto; margin-top: 20px; margin-left: 2px;">
              <i class="fas fa-edit"></i>
            </button>
          </div>

          <div class="w3-col s8 m8 l8">
            <label for="quantidade" class="w3-block w3-margin-top">Quantidade</label>
            <strong for="quantidade" class="w3-block">{{nPadrao(quantidade, 3)}}</strong>
          </div>
        </div>

        <div class="w3-col s6 m8 w3-margin-bottom">
          <button
            v-if="alterar_quantidade"
            class="w3-button w3-theme"
            @click="gravarAlteracaoQuantidade"
            style="margin: auto; margin-top: 20px; margin-left: 2px;">
            <i class="fas fa-check"></i>
            <span>Aplicar quantidade</span>
          </button>

          <button
            v-if="!alterar_quantidade"
            class="w3-button w3-green w3-margin-left"
            @click="lerCodigoBarras(codigo_barras)"
            style="margin: auto; margin-top: 20px;">
            <i class="fas fa-check"></i>
            <span>Confirmar</span>
          </button>
        </div>
      </div>

      <div
        class="w3-container">

        <div
          class="w3-border card-itens w3-left"
          :key="index"
          v-for="(item, index) in itens"
          :class="{'card-informacoes-selecionado': item.verificado}"
          @click="conferirItemManualmente(item, !item.verificado)">

          <div class="w3-col l6">
            <strong v-if="opcao_confirmacao == 'MAN'">{{item.produto_id}} - </strong>
            <strong>{{item.nome}}</strong>
          </div>

          <div class="w3-col m6 l6">
            <label class="w3-left">Marca:&nbsp;</label>
            <strong class="w3-left">{{item.marca}}</strong>
          </div>

          <div class="w3-col m6 l6" v-if="item.lote">
            <label class="w3-left">Lote:&nbsp;</label>
            <strong class="w3-left">{{item.lote}}</strong>
          </div>

          <div class="w3-col m6 l6" v-if="item.codigo_original">
            <label class="w3-left">Cód.oringinal:&nbsp;</label>
            <strong class="w3-left">{{item.codigo_original}}</strong>
          </div>

          <div class="w3-col m6 l6" v-if="item.tipo_controle_numero_serie != 'N'">
            <label class="w3-left">Controle de nº. serie:&nbsp;</label>
            <strong class="w3-left">
              <span>{{getTipoControleNumeroSerie(item.tipo_controle_numero_serie)}}</span>
            </strong>
          </div>

          <div class="w3-col l12" v-if="item.unidade_entrega_multiplo_venda">
            <label class="w3-left">Quantidade total:&nbsp;</label>
            <strong>de {{nPadrao(item.quantidade, 3)}} </strong>
            <strong>({{item.unidade}})</strong> 
          </div>

          <div class="w3-col l12" v-if="item.unidade_entrega_multiplo_venda">
            <label class="w3-left">Conferido:&nbsp;</label>
            <strong style="color: blue;">{{nPadrao(item.quantidade_conferida, 3)}} </strong>
            <strong>de {{nPadrao(item.quantidade_entrega_multiplo_venda, 3)}} </strong>
            <strong>({{item.unidade_entrega_multiplo_venda}})</strong> 
          </div>

          <div class="w3-col l12" v-if="!item.unidade_entrega_multiplo_venda">
            <label class="w3-left">Conferido:&nbsp;</label>
            <strong style="color: blue;">{{nPadrao(item.quantidade_conferida, 3)}} </strong>
            <strong>de {{nPadrao(item.quantidade, 3)}} </strong>
            <strong>({{item.unidade}})</strong> 
          </div>

        </div>
      </div>

      <div class="w3-container" v-if="(opcao_confirmacao == 'MAN') || (todosItensVerificados)">
        <div class="w3-center">
          <button
            :disabled="!todosItensVerificados"
            class="w3-button w3-theme"
            @click="concluirConferencia()"
            style="margin: auto; margin-top: 10px; margin-bottom:10px">
            <i class="fas fa-check"></i>
            <span>OK</span>
          </button>
        </div>
      </div>
    </div>

    <transition name="w3-modal">
      <div class="modal-mask" v-if="mostrar_leitor_codigo_barras">
        <div class="modal-wrapper" @click="fecharLeitosCodigoBarras()">
          <div class="modal-container w3-modal-content" @click.stop>
            <header class="w3-container modal-wrapper">
              <span
                @click="fecharLeitosCodigoBarras()"
                class="w3-button w3-display-topright">&times;</span>

              <button class="texto-vermelho titulo w3-col s12">
                <i class="fas fa-camera"></i><span> Leitor</span>
              </button>
            </header>

            <div class="w3-container" v-if="mostrar_leitor" style="overflow: hidden; height: 500px;">
              <v-quagga
                :onDetected="detec"
                :onProcessed="onProcessed"
                :readerSize="render_size"
                :aspectRatio="aspect_ratio"
                :readerTypes="[
                  'ean_reader',
                  'i2of5_reader',
                  '2of5_reader',
                  'code_128_reader',
                  'code_39_reader',
                  'code_39_vin_reader',
                  'codabar_reader',
                  'upc_e_reader',
                  'upc_reader'
                ]">
              </v-quagga>
            </div>

            <button
              class="w3-button w3-theme"
              @click="fecharLeitosCodigoBarras()"
              style="margin: auto; margin-top: 10px; margin-bottom:10px">
              <span>Fechar</span>
            </button>
          </div>
        </div>
      </div>
    </transition>

    <div class="modal-mask" v-if="mostrar_modal_lotes">
      <div class="modal-wrapper">
        
        <div class="modal-container w3-modal-content">
          <header class="w3-container">
            <h2 class="texto-vermelho titulo">
              <i class="fas fa-shopping-cart"></i>
              <span> Selecione o Lote</span>

              <span
                @click="fecharModalLotes()"
                class="w3-button w3-display-topright">&times;</span>
            </h2>
          </header>

          <div class="w3-container">
            <div class="w3-container">
              <div class="w3-col">
                <label>Produto: </label>
                <strong>{{itens_selecao_lote[0].produto_id}} - </strong>
                <strong>{{itens_selecao_lote[0].nome}}</strong>
              </div>

              <div class="w3-col" v-if="itens_selecao_lote[0].marca">
                <label>Marca: </label>
                <strong>{{itens_selecao_lote[0].marca}}</strong>
              </div>
            </div>

            <button
              v-for="(item, index) in itens_selecao_lote"
              :key="index"
              class="w3-button w3-theme w3-margin"
              @click="aplicarDefinicaoLote(item)">
              <span>{{item.lote}}</span>
            </button>

          </div>
        </div>
      </div>
    </div>

    <div>
      <audio controls id="alerta-poket" hidden preload="auto">
        <source 
          src="../assets/audio/alertapocket.mp3"
          type="audio/mpeg"> 
          Seu browser não suporta o uso de arquivos no formato mp3
      </audio>
      
      <audio 
        controls id="leitura-poket"
        hidden preload="auto">
        <source
          src="../assets/audio/leiturapocket.mp3" 
          type="audio/mpeg"> 
          Seu browser não suporta o uso de arquivos no formato mp3
      </audio>
    </div>

  </div>
</template>

<script>
  import toastr from 'toastr';
  import Quagga from 'quagga';
  import VueNumeric from 'vue-numeric';
  import VueQuagga from 'vue-quaggajs';
  import Biblioteca from '@/components/Repositorio/Biblioteca';
  import ValidacaoCodigoBarras from '@/components/Repositorio/ValidacaoCodigoBarras';
  import formatarValorMixin from '@/mixins/formatarValorMixin.js';
  import RProdutoBuscarCodigosBarrasProdutos from '@/components/Rest/RProduto/RProdutoBuscarCodigosBarrasProdutos.js';
  import RProdutoBuscarProdutoPorIdOuCodigoBarras from '@/components/Rest/RProduto/RProdutoBuscarProdutoPorIdOuCodigoBarras.js';

  export default {
    name: 'ModalConferencia',

    components: {
      Quagga,
      VueQuagga,
      VueNumeric
    },

    mixins:[formatarValorMixin],

    props: {
      tipoConfirmacao: {
        type: String,
        default: 'MAN',
        required: false
      },

      utilizaBalanca: {
        type: String,
        required: false
      },
    },

    data() {
      return {
        quantidade: 1,
        codigo_barras: '',

        itens: [],

        visivel: false,
        opcao_confirmacao: 'MAN',
        alterar_quantidade: false,
        pode_modificar_opcao_confirmacao: false,

        codigos_barras: [],
        item_selecionado: {},
        itens_selecao_lote: [],

        mostrar_leitor: true,
        mostrar_modal_lotes: false,
        mostrar_leitor_codigo_barras: false,

        render_size: {
          width: 200,
          height: 280
        },

        aspect_ratio: {
          min: 1,
          max: 1
        }
      }
    },

    methods: {
      abrir(itens_conferir) {
        if ((!itens_conferir) || (itens_conferir.length == 0)) {
          toastr.error('Informe os itens para conferência!');
          return;
        }

        this.itens = JSON.parse(JSON.stringify(itens_conferir));
        for (let i = 0; i < this.itens.length; i++) {
          this.itens[i].quantidade_conferida = 0;

          this.itens[i].quantidade = Biblioteca.valor(
            this.itens[i].quantidade
          );

          this.itens[i].multiplo_venda = Biblioteca.valor(
            this.itens[i].multiplo_venda
          );

          this.itens[i].quantidade_entrega_multiplo_venda = Biblioteca.valor(
            this.itens[i].quantidade_entrega_multiplo_venda
          );
        }

        /* PARAMETROS_EMPRESA.tipoConfirmacao_ENT_CAIXA */
        /* SCB - Selecionar a opção - Default Cod. barras */
        /* SMA - Selecionar a opção - Default Manual      */
        /* MAN - SOMENTE Opção manual                     */
        /* BAR - SOMENTE Opção código de barras           */
        if (!Biblioteca.em(this.tipoConfirmacao, ['SCB', 'SMA', 'MAN', 'BAR'])) {
          toastr.error('Defina um tipo válido de confirmação!');
          return;
        }

        if (!Biblioteca.em(this.utilizaBalanca, ['S', 'N'])) {
          toastr.error('É necessário definir a parametrização de utilização de balança!');
          return;
        }

        this.buscarCodigosBarrasProdutos();

        this.pode_modificar_opcao_confirmacao = false;
        if (Biblioteca.em(this.tipoConfirmacao, ['SCB', 'SMA'])) {
          this.pode_modificar_opcao_confirmacao = true;
        }

        if (Biblioteca.em(this.tipoConfirmacao, ['SCB', 'BAR'])) {
          this.opcao_confirmacao = 'BAR';
        }

        if (Biblioteca.em(this.tipoConfirmacao, ['SMA', 'MAN'])) {
          this.opcao_confirmacao = 'MAN';
        }

        this.alterar_quantidade = false;
        this.quantidade = 1;
        this.visivel = true;

        if (Biblioteca.em(this.tipoConfirmacao, ['SCB', 'BAR'])) {
          this.$nextTick(() => this.$refs.campoCodigoBarras.focus());
        }
      },

      fechar() {
        this.visivel = false;
      },

      clicarOpcaoCodigoBarras() {
        this.$nextTick(() => this.$refs.campoCodigoBarras.focus());
      },

      async buscarCodigosBarrasProdutos() {
        this.codigos_barras = [];

        let produtos_ids = [];
        for (let i = 0; i < this.itens.length; i++) {
          produtos_ids.push(this.itens[i].produto_id);
        }

        let parametros = {
          produtos_ids: produtos_ids
        }
        let retorno = await RProdutoBuscarCodigosBarrasProdutos.buscarCodigosBarrasProdutos(
          this.axios,
          parametros
        );

        if (retorno.houve_erro != 'N') {
          return;
        }

        this.codigos_barras = JSON.parse(JSON.stringify(retorno.dados));
      },

      ativarEdicaoQuantidade() {
        this.alterar_quantidade = true;
        this.quantidade = 0;
      },

      gravarAlteracaoQuantidade() {
        if (this.quantidade < 0) {
          toastr.error('A quantidade não pode ser negativa!');
          return;
        }

        if (Biblioteca.nPadrao(this.quantidade, 3) == Biblioteca.nPadrao(0, 3)) {
          toastr.error('Informe a quantidade!');
          return;
        }

        this.alterar_quantidade = !this.alterar_quantidade;
      },

      alertaSonoro(mensagem) {
        /* Mensagem */
        toastr.error(mensagem);

        /* Vibração do celular */
        vibrar();

        /* Aviso sonoro */
        const audio =  document.querySelector('#alerta-poket')
        if (!audio)  return;
        audio.currentTime = 0;
        audio.play();
      },

      leituraSonora() {
        toastr.success('Item lançado!');
        const audio = document.querySelector('audio#leitura-poket');
        if (!audio)  return;
        audio.currentTime = 0;
        audio.play();
      },

      getTipoControleNumeroSerie(tipo_controle_numero_serie) {
        if (tipo_controle_numero_serie == 'N') {
          return 'Nenhum';
        }
        else if (tipo_controle_numero_serie == 'S') {
          return 'Saída';
        }
        else if (tipo_controle_numero_serie == 'T') {
          return 'Entrada e saída'
        }
      },

      onProcessed(result) {
        let drawingCtx = Quagga.canvas.ctx.overlay,
        drawingCanvas = Quagga.canvas.dom.overlay;

        if (result) {
          if (result.boxes) {
            drawingCtx.clearRect(
              0,
              0,
              parseInt(drawingCanvas.getAttribute("width")),
              parseInt(drawingCanvas.getAttribute("height"))
            );
            
            result.boxes.filter(
              function (box) {
                return box !== result.box;
              }
            ).forEach(function (box) {
              Quagga.ImageDebug.drawPath(
                box,
                {x: 0, y: 1},
                drawingCtx,
                {color: "green", lineWidth: 2}
              );
            });
          }

          if (result.box) {
            Quagga.ImageDebug.drawPath(
              result.box,
              {x: 0, y: 1},
              drawingCtx,
              {color: "#00F", lineWidth: 2}
            );
          }

          if (result.codeResult && result.codeResult.code) {
            Quagga.ImageDebug.drawPath(
              result.line,
              {x: 'x', y: 'y'},
              drawingCtx,
              {color: 'red', lineWidth: 3}
            );
          }
        }
      },

      detec(result) {
        this.fecharLeitosCodigoBarras();
        this.lerCodigoBarras(result.codeResult.code);
      },

      async validarDefinicaoCodigoBarras(codigo_barras, unidade_produto) {
        let validacao_retorno = {
          houve_erro: 'N',
          mensagem: '',
          qtd_total: this.quantidade,
          produto_id: 0,
          quantidade_caixa_fechada: 0,
          verificar_item_id_tinta_manipulada: false
        }

        if (codigo_barras == '') {
          validacao_retorno.houve_erro = 'S';
          validacao_retorno.mensagem = 'Informe o código de barras!';
          
          return validacao_retorno;
        }

        if 
          (
            (this.utilizaBalanca == 'S') &&
            (ValidacaoCodigoBarras.eCodigoBalancaInterno(codigo_barras))
          ) 
        {
          codigo_barras = ValidacaoCodigoBarras.tratarCodigoBarrasInterno(
            codigo_barras,
            true,
            true,
            false,
            this.utilizaBalanca
          );

          let divisor = 1;
          if (unidade_produto == 'UN') {
            divisor = 1000;
          }

          validacao_retorno.qtd_total = Biblioteca.nPadrao(
            ValidacaoCodigoBarras.extrairQuantidadeCodigoBalancaInterno(codigo_barras) /
            divisor
          );

          if (codigo_barra.length <= 7) {
            validacao_retorno.produto_id = Biblioteca.valorInt(codigo_barra);
            validacao_retorno.houve_erro = 'N';

            return validacao_retorno;
          }
        }

        validacao_retorno.verificar_item_id_tinta_manipulada = false;

        let codigo_checar = Biblioteca.valorInt(codigo_barras);
        if (codigo_checar <= 0) {
          codigo_checar = ''
        };

        if 
          (
            ValidacaoCodigoBarras.eCodigoBarraProdutoInterno(codigo_checar) &&
            !(
              (codigo_barras.substring(0, 2) == '985') &&
              (Biblioteca.em(codigo_barras.length, [13, 14]))
            )
          ) 
        {
          validacao_retorno.produto_id = Biblioteca.valorInt(codigo_barras);
        }
        else {
          let parametros = {
            chave_pesquisa: codigo_barras
          }

          let retorno = await RProdutoBuscarProdutoPorIdOuCodigoBarras.buscarProduto(this.axios, parametros);
          
          if (retorno.houve_erro != 'N'){
            validacao_retorno.houve_erro = 'S';
            validacao_retorno.mensagem = retorno.mensagem;
            
            return validacao_retorno;
          }

          // Convertendo para número
          validacao_retorno.produto_id = Biblioteca.valorInt(retorno.dados.produto_id);
          validacao_retorno.quantidade_caixa_fechada = Biblioteca.valor(retorno.dados.quantidade_caixa_fechada);
          // Verificando se existe quantidade na caixa
          validacao_retorno.quantidade_caixa_fechada = validacao_retorno.quantidade_caixa_fechada > 0 ? validacao_retorno.quantidade_caixa_fechada : 1; 

          if (codigo_barras.length == 13) {
            validacao_retorno.item_id = Biblioteca.valor(codigo_barras.substring(10, 12));
          }
          else {
            validacao_retorno.item_id = Biblioteca.valor(codigo_barras.substring(11, 13));
          }

          if (validacao_retorno.produto_id > 0) {
            if 
            (
              (codigo_barras.substr(0, 2) == '985') && 
              Biblioteca.em(codigo_barras.length, [13, 14])
            ) {
              validacao_retorno.verificar_item_id_tinta_manipulada = true;
            }
          }
        }

        if (validacao_retorno.produto_id > 0) {
          if (await this.buscarPermitirInformarQuantidadeConferencia(validacao_retorno.produto_id) == 'N') {
            validacao_retorno.qtd_total = 1;
          }
        }

        return validacao_retorno;
      },

      buscarPermitirInformarQuantidadeConferencia(produto_id) {
        for (let i = 0; i < this.itens.length; i++) {
          if (Biblioteca.numeros(this.itens[i].produto_id) == Biblioteca.numeros(produto_id)) {
            return this.itens[i].perm_informar_qtd_conferencia;
          }
        }

        return 'N';
      },

      buscarProdutoPorIdOuCodigoBarras(codigo_barras) {
        if (!this.codigos_barras) {
          return undefined;
        }

        if (this.codigos_barras.length == 0) {
          return undefined;
        }

        for (let i = 0; i < this.codigos_barras.length; i++) {
          if (Biblioteca.numeros(this.codigos_barras[i].codigo_barras) == Biblioteca.numeros(codigo_barras)) {
            return this.codigos_barras[i].produto_id;
          }
        }

        return undefined;
      },

      buscarItensProdutoId(produto_id) {
        if (!this.itens) {
          return [];
        }

        let retorno = [];
        for (let i = 0; i < this.itens.length; i++) {
          if (Biblioteca.valorInt(this.itens[i].produto_id) != Biblioteca.valorInt(produto_id)) {
            continue;
          }

          retorno.push(JSON.parse(JSON.stringify(this.itens[i])));
        }

        return retorno;
      },

      async lerCodigoBarras(codigo_barras) {
        if ((!codigo_barras) || (codigo_barras.length == 0)) {
          toastr.error('É nescessário informar um código de barras válido!');
          return;
        }

        let retorno = await this.validarDefinicaoCodigoBarras(codigo_barras);

        if (retorno.houve_erro != 'N') {
          toastr.error(retorno.mensagem);
          return;
        }

        if ((!retorno.qtd_total) || ((retorno.qtd_total * retorno.quantidade_caixa_fechada) <= 0)) {
          toastr.error('A quantidade da leitura não foi definida!');
          return;
        }

        this.quantidade = retorno.qtd_total * retorno.quantidade_caixa_fechada;
        this.itens_selecao_lote = await this.buscarItensProdutoId(retorno.produto_id);

        if ((!this.itens_selecao_lote) || (this.itens_selecao_lote.length == 0)) {
          toastr.error('O produto da leitura não está incluso nesta conferência!');
          return;
        }

        if (this.itens_selecao_lote.length > 1) {
          this.mostrar_modal_lotes = true;
          return;
        }

        this.aplicarDefinicaoLote(this.itens_selecao_lote[0]);
      },

      efetivarConferenciaItem(item) {
        for (let i = 0; i < this.itens.length; i++) {
          if (this.itens[i].indice == item.indice) {
            this.itens[i].quantidade_conferida += this.quantidade;
            break;
          }
        }

        this.codigo_barras = '';
        this.quantidade = 1;

        let tem_item_pendente = false;
        for (let i = 0; i < this.itens.length; i++) {
          if (this.itens[i].unidade_entrega_multiplo_venda){
            if (
              (Biblioteca.nPadrao(this.itens[i].quantidade_entrega_multiplo_venda, 3)) == 
              (Biblioteca.nPadrao(this.itens[i].quantidade_conferida, 3))
            ) {
              this.itens[i].verificado = true;
            }
            else {
              this.itens[i].verificado = false;
              tem_item_pendente = true;
            }
          } else {
            if (
              (Biblioteca.nPadrao(this.itens[i].quantidade, 3)) == 
              (Biblioteca.nPadrao(this.itens[i].quantidade_conferida, 3))
            ) {
              this.itens[i].verificado = true;
            }
            else {
              this.itens[i].verificado = false;
              tem_item_pendente = true;
            }
          }
        }

        this.itens = JSON.parse(JSON.stringify(this.itens));

        if ((tem_item_pendente) && (this.opcao_confirmacao == 'BAR')) {
          this.$nextTick(() => this.$refs.campoCodigoBarras.focus());
          return;
        }
      },

      fecharModalLotes() {
        toastr.error('Operação cancelada pelo usuário!');
        this.codigo_barras = '';
        this.quantidade = 1;
        this.mostrar_modal_lotes = false;
      },

      aplicarDefinicaoLote(item) {
        let quantidade_teste = item.quantidade_conferida + this.quantidade;
        let houve_quantidade_excedida = false;

        if 
          (
            (item.unidade_entrega_multiplo_venda) && 
            (quantidade_teste > item.quantidade_entrega_multiplo_venda)
          ) 
        { /* Verificando se a quantidade conferida e maior que a quantidade informada do multiplo */
          houve_quantidade_excedida = true;
        } else if (quantidade_teste > item.quantidade) { /* Verificando se a quantidade conferida e maior que a quantidade informada */
          houve_quantidade_excedida = true;
        }

        if (houve_quantidade_excedida){
          this.alertaSonoro('Quantidade da leitura excede a quantidade total!');
          this.codigo_barras = '';
          this.quantidade = 1;
          return;
        }

        this.mostrar_modal_lotes = false;
        this.efetivarConferenciaItem(item);
      },

      fecharLotes() {
        this.mostrar_modal_lotes = false;
      },

      fecharLeitosCodigoBarras() {
        Quagga.offDetected();
        Quagga.stop();
        this.mostrar_leitor_codigo_barras = false;
      },

      conferirItemManualmente(item, esta_verificado) {
        if (this.opcao_confirmacao != 'MAN') {
          return;
        }

        if (item.bloqueado) {
          return;
        }

        if (esta_verificado) {
          if (item.unidade_entrega_multiplo_venda) {
            this.$set(item, 'quantidade_conferida', item.quantidade_entrega_multiplo_venda);
          } else {
            this.$set(item, 'quantidade_conferida', item.quantidade);
          }
        }
        else {
          this.$set(item, 'quantidade_conferida', 0);
        }

        this.$set(item, 'verificado', esta_verificado);
      },

      concluirConferencia() {
        this.$emit('confirmar', this.itens);
        this.visivel = false;
      },

      nPadrao(numero, casas_decimais = 2) {
        return Biblioteca.nPadrao(numero, casas_decimais);
      }
    },

    computed: {
      todosItensVerificados() {
        for (let i = 0; i < this.itens.length; i++) {
          if (this.itens[i].unidade_entrega_multiplo_venda) {
            if (
              nPadrao(this.itens[i].quantidade_conferida, 3) !=
              nPadrao(this.itens[i].quantidade_entrega_multiplo_venda, 3)
            ) {
              return false;
            }

          } else {
            if (
              nPadrao(this.itens[i].quantidade_conferida, 3) !=
              nPadrao(this.itens[i].quantidade, 3)
            ) {
              return false;
            }
          }
        }

        return true;
      }
    },

    filters: {
      letraMaiuscula: function(value, apenasPrimeiraLetra) {
        if (!value) {
          return '';
        }

        value = value.toString();

        if (apenasPrimeiraLetra) {
          return value.toLowerCase().split(' ').map(
            (s) => s.charAt(0).toUpperCase() + s.substring(1)
          ).join(' ');
        }
        else {
          return value.toUpperCase();
        }
      }
    }
  }
</script>

<style scoped>
  .card-itens {
    margin-bottom: 10px;
    border-left-style: solid;
    border-left-color: #636363;
    border-bottom-style: solid;    
    float: left;
    padding: 7px;
    border-bottom-color: #636363 !important;
    cursor: pointer;
    transition: 0.2s;
    width: 100%;
    border-radius: 10px;
    box-shadow: #d1d1d1 1px 3px 5px 3px ;
    background-color: #f3f3f3;
  }

  .card-informacoes {
    margin-bottom: 10px;
    border-left-style: solid;
    border-left-color: #636363;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    float: left;
    padding: 7px;
    border-bottom-color: #636363 !important;
    cursor: pointer;
    transition: 0.2s;
    width: 100%;
  }

  .card-informacoes-selecionado {
    background: #4caf5085;
  }

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  @media (min-width: 993px) {
    .modal-container {
      width: 1010px;
    }
  }

  @media (max-width: 768px) {
    .modal-container {
      width: 600px;
    }
  }

  @media (max-width: 605px) {
    .modal-container {
      width: 320px !important;
    }

    .container-items {
      max-height: 230px !important;
    }
  }

  .modal-container {
    border-radius: 12px;
    margin: auto;
    height: auto;
    padding: 10px 10px;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    animation: animatezoom 0.6s;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  button {
    background: #9c1d1c;
    color: white;
    padding: 10px;
    border: 0 !important
  }

  .tr-titulo {
    padding: 10px !important;
    background: #565454b8;
    color:white
  }

  .processar-btn {
    margin-top: 10px;
    padding: 5px;
  }

  .pesquisar-titulo {
    margin: auto;
    text-align: center;
    cursor: pointer;
    border: #636363 1px solid;
    padding: 10px;
    transition: 0.1s;
    background: #9c1d1c;
    color: white;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 22px;
  }

  .pesquisar-titulo:hover {
    background: white;
    color: black;
  }

  .tr-items-ativo:hover {
    background: #9c1d1c69 !important;
  }

  .tr-items-ativo {
    background:#9c1d1c2e !important;
  }

  .tr-items {
    cursor: pointer;
    transition: 0.2s;
  }

  .tr-items:hover {
    background: #9c1d1cb8;
    color:#fff;
  }

  td {
    white-space: nowrap;
    text-align: center;
  }

  .w3-input {
    border: 1px solid gray;
  }

  .container-items {
    max-height: 300px;
    overflow: auto;
  }

  .w3-container {
    padding: 0 !important;
  }

  .w3-table td {
    padding: 4px 8px;
  }

  .scroll-modal-conferencia {
    max-height: 100%;
    overflow-y: auto;
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #ddd;
  }

  ::-webkit-scrollbar-thumb {
    background: #8d1007;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #9c1d1c;
  }
</style>



// WEBPACK FOOTER //
// src/components/ModalConferencia.vue